import regions from "./region.json";
export const getRegionFromLongName = (regionLongName) => {
    if (!regionLongName) {
        return undefined;
    }
    ;
    return regions.find(region => region.region_name.toLowerCase() === regionLongName.toLowerCase());
};
export const getRegions = () => {
    const uniqCodes = regions.map(reg => reg.region_code).sort().filter((val, pos, arr) => {
        return !pos || val != arr[pos - 1];
    });
    return uniqCodes.map(code => {
        return regions.find(region => region.region_code === code);
    });
};
